import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {updateCandidateProfile} from '../actionCreators';

const useCandidateSave = (candidateId, onDuplicatesFound, autoOpen = false) => {
  const dispatch = useDispatch();

  return useCallback(
    data => dispatch(updateCandidateProfile(candidateId, data, onDuplicatesFound, autoOpen)),
    [dispatch, candidateId, onDuplicatesFound, autoOpen]
  );
};

export default useCandidateSave;
